import React from 'react';
import { cx } from './cx';
import { formatStack } from './formatStack';

export interface InventoryItem {
  name: string;
  image?: string;
  quantity?: number;
}

interface InventorySlotProps {
  item?: InventoryItem;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}

const InventorySlot: React.FC<InventorySlotProps> = ({
  item,
  selected,
  disabled = false,
  onClick,
  className,
}) => {
  const label = item?.name ?? 'Empty slot';
  return (
    <button
      type="button"
      className={cx('osrs-slot', selected && 'osrs-slot--selected', className)}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      aria-pressed={selected}
    >
      {item?.image ? (
        <img src={item.image} alt="" />
      ) : null}
      {item?.quantity !== undefined && item.quantity > 1 && (
        <span className="osrs-slot__qty">{formatStack(item.quantity)}</span>
      )}
    </button>
  );
};

export default InventorySlot;
